module.exports = __webpack_public_path__ + "img/tomato.ff89101e.png";